import { environment } from 'environment';
import { createJSONStorage, devtools as reduxDevtools } from 'zustand/middleware';

const devtoolsImpl =
  environment.name !== 'production' && typeof window !== 'undefined' ? reduxDevtools : (fn: unknown) => fn;
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const devtools = devtoolsImpl as unknown as typeof reduxDevtools;

export const getStorage = () => {
  if (typeof window === 'undefined') return null;
  return createJSONStorage(() => window.localStorage);
};
